export type AttachmentViewState = 'loading' | 'empty' | 'error' | 'ready';

export const ATTACHMENT_EMPTY_MESSAGE_ID = 'eventTypes.component.notAdded';
export const ATTACHMENT_ERROR_MESSAGE_ID = 'eventTypes.component.notFound';
export const ATTACHMENT_PDF_ERROR_MESSAGE_ID = 'eventTypes.component.notFoundPdf';

export const getAttachmentViewState = ({
  error,
  isLoading,
  sourceCount,
}: {
  error: boolean;
  isLoading: boolean;
  sourceCount: number;
}): AttachmentViewState => {
  if (error) {
    return 'error';
  }
  if (sourceCount === 0) {
    return 'empty';
  }
  if (isLoading) {
    return 'loading';
  }
  return 'ready';
};

export const getPhotoPdfItemMessageId = (photo: {
  blob?: unknown;
  urlDownloaded?: string;
}): typeof ATTACHMENT_PDF_ERROR_MESSAGE_ID | null => {
  if (photo.blob || photo.urlDownloaded) {
    return null;
  }
  return ATTACHMENT_PDF_ERROR_MESSAGE_ID;
};
